import React from "react";
import { Container } from "react-bootstrap";
import { Link } from 'react-router-dom';
import SEO from "../SEO/SEO";
import './EnviosYDevoluciones.css'

const CondicionesGeneralesVenta = () => {
    const sections = [
        {
            title: "Uso del sitio",
            text: "La web permite conocer quienes somos, donde estamos, que hacemos y que productos forman parte de nuestro catalogo. No procesa compras, pagos, pedidos, envios ni cuentas de usuario."
        },
        {
            title: "Mayoria de edad",
            text: "Whisky&Co comunica productos con alcohol. El acceso al sitio esta destinado exclusivamente a personas mayores de 18 anos."
        },
        {
            title: "Catalogo y disponibilidad",
            text: "Imagenes, descripciones, categorias, precios, promociones y destacados tienen caracter informativo. La disponibilidad y las condiciones finales se confirman por contacto directo."
        },
        {
            title: "Consultas por WhatsApp",
            text: "Una consulta iniciada desde el sitio no implica reserva ni operacion confirmada. Sirve para abrir una conversacion directa con Whisky&Co."
        },
        {
            title: "Propiedad intelectual",
            text: "Textos, imagenes, diseno, marca y recursos visuales pertenecen a Whisky&Co o se utilizan con autorizacion. No pueden reutilizarse sin permiso previo."
        },
        {
            title: "Legislacion aplicable",
            text: "Estas condiciones se rigen por las leyes de la Republica Argentina. Ante controversias, seran competentes los tribunales ordinarios de Cordoba."
        },
    ];

    return (
        <main className="legal-page">
            <SEO
                title="Condiciones de uso | Whisky And Co"
                description="Condiciones de uso del sitio, catalogo publico y contacto con Whisky&Co."
                canonicalPath="/condiciones-generales"
            />

            <Container className="legal-shell">
                <section className="legal-hero">
                    <span className="legal-kicker">Marco de uso</span>
                    <h1>Condiciones de Uso del Sitio</h1>
                    <p>
                        Estas pautas ordenan el uso de whiskyandco.com.ar como canal institucional, catalogo publico y puente de contacto con nuestro local.
                    </p>
                </section>

                <section className="legal-layout">
                    <aside className="legal-summary">
                        <span className="legal-summary-label">Datos del sitio</span>
                        <p>
                            <strong>Whisky&Co</strong><br />
                            Av. Recta Martinolli 8669<br />
                            Cordoba, Argentina
                        </p>
                        <Link to="/politica-de-privacidad" className="legal-summary-link">
                            Ver privacidad y cookies
                        </Link>
                    </aside>

                    <div className="legal-content legal-grid">
                        {sections.map((section, index) => (
                            <article className="legal-card" key={section.title}>
                                <span className="legal-card-number">{String(index + 1).padStart(2, "0")}</span>
                                <h2>{section.title}</h2>
                                <p>{section.text}</p>
                            </article>
                        ))}

                        <article className="legal-card legal-card-wide">
                            <span className="legal-card-number">07</span>
                            <h2>Contacto</h2>
                            <p>
                                Para consultas sobre el sitio, productos o atencion, podes comunicarte por WhatsApp al <strong>+54 351 529-5096</strong> o visitar nuestro local.
                            </p>
                        </article>
                    </div>
                </section>
            </Container>
        </main>
    );
};

export default CondicionesGeneralesVenta;
